<template>
    <div class="wrap">
        <toshiba v-if="isToshiba" />
        <msmartlife v-else />
    </div>
</template>
<script>
import msmartlife from './views/msmartlife.vue';
import toshiba from './views/toshiba.vue';
export default {
    components: { msmartlife, toshiba },
    data () {
        return {
            isToshiba: false
        };
    },
    created () {
        if (/smartiolife/i.test(location.href) || /tsmart/i.test(location.href)) {
            this.isToshiba = true;
        }
        console.log('isToshiba:', this.isToshiba);
    }
};
</script>
<style scoped>
.wrap{
    width: 100%;
    height: 100%;
}
</style>
